@if (event) {
    <ms-event-switcher-toggle [event]="event" [mediaCount]="mediaTabsCount" />
    @if (!event.scoreboard.isFinished) {
        <ms-media-switcher [event]="event" (mediaTabsCountChanged)="onTabsChanged($event)" />
    }
}
